import CallIcon from '@mui/icons-material/Call';
import DialpadIcon from '@mui/icons-material/Dialpad';
import {
  Box,
  Button,
  ClickAwayListener,
  IconButton,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { PhoneNumberUtil } from 'google-libphonenumber';
import React, { useEffect, useState } from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValidCheck = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch {
    return false;
  }
};

const PhoneDialerPopper = ({
  countryCode2,
  phoneNumber,
  setPhoneNumber,
  onClose,
  onSubmit,
}) => {
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [displayDialer, setDisplayDialer] = useState(false);

  useEffect(() => {
    if (phoneNumber === '00') {
      setPhoneNumber((_state) => '+');
    }
    setIsPhoneValid(isPhoneValidCheck(phoneNumber));
  }, [phoneNumber]);

  const handleDisplayDialer = () => {
    setDisplayDialer((state) => !state);
  };

  // Fonction pour gérer la saisie via le pavé numérique
  const handleNumberClick = (num) => {
    setPhoneNumber(phoneNumber + num);
  };

  const handleDelete = () => {
    setPhoneNumber('');
  };

  const handleSubmit = () => {
    onSubmit();
    onClose();
  };

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Paper sx={{ padding: 2 }}>
        <Typography variant="h6">Entrez le numéro de téléphone</Typography>
        <Box
          sx={{ margin: 2, display: 'flex', justifyContent: 'space-evenly' }}
        >
          <PhoneInput
            value={phoneNumber}
            defaultCountry={countryCode2}
            // margin="normal"
            fullWidth
            onChange={(phone) => setPhoneNumber(phone)}
          />
          <IconButton onClick={handleDisplayDialer}>
            <DialpadIcon />
          </IconButton>
        </Box>
        <Stack spacing={2}>
          {displayDialer ? (
            <>
              {[
                [1, 2, 3],
                [4, 5, 6],
                [7, 8, 9],
                ['*', 0, '#'],
              ].map((line) => (
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={'center'}
                  key={line}
                >
                  {line.map((num) => (
                    <Button
                      key={num}
                      variant="contained"
                      onClick={() => handleNumberClick(num)}
                      sx={{ borderRadius: '100%' }}
                    >
                      {num}
                    </Button>
                  ))}
                </Stack>
              ))}
            </>
          ) : null}
          <Stack direction="row" spacing={2}>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={handleDelete}
            >
              Supprimer
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={handleSubmit}
              startIcon={<CallIcon />}
              disabled={!isPhoneValid}
            >
              Appeler
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </ClickAwayListener>
  );
};

export default PhoneDialerPopper;
